export var TeachAppAndLandingColorPalette;
(function (TeachAppAndLandingColorPalette) {
    TeachAppAndLandingColorPalette["blue_700"] = "rgba(130, 178, 255, 1)";
    TeachAppAndLandingColorPalette["blue_600"] = "rgba(226, 236, 255, 1)";
    TeachAppAndLandingColorPalette["blue_600_50"] = "rgba(226, 236, 255, 0.5)";
    TeachAppAndLandingColorPalette["blue_400"] = "rgba(240, 245, 255, 1)";
    TeachAppAndLandingColorPalette["blue_100"] = "rgba(249, 251, 255, 1)";
    TeachAppAndLandingColorPalette["blue_100_70"] = "rgba(249, 251, 255, 0.7)";
    TeachAppAndLandingColorPalette["green_600"] = "rgba(1, 135, 135, 1)";
    TeachAppAndLandingColorPalette["green_500"] = "rgba(107, 212, 199, 1)";
    TeachAppAndLandingColorPalette["green_500_30"] = "rgba(107, 212, 199, 0.3)";
    TeachAppAndLandingColorPalette["grey_100"] = "rgba(247, 248, 253, 1)";
    TeachAppAndLandingColorPalette["grey_600"] = "rgba(51, 69, 91, 1)";
    TeachAppAndLandingColorPalette["grey_600_20"] = "rgba(51, 69, 91, 0.2)";
    TeachAppAndLandingColorPalette["grey_500"] = "rgba(92, 106, 124, 1)";
    TeachAppAndLandingColorPalette["grey_200"] = "rgba(215, 226, 233, 1)";
    TeachAppAndLandingColorPalette["purple_700"] = "rgba(62, 74, 128, 1)";
    TeachAppAndLandingColorPalette["purple_600"] = "rgba(64, 74, 148, 1)";
    TeachAppAndLandingColorPalette["purple_600_90"] = "rgba(64, 74, 148, 0.9)";
    TeachAppAndLandingColorPalette["purple_600_50"] = "rgba(64, 74, 148, 0.5)";
    TeachAppAndLandingColorPalette["purple_600_10"] = "rgba(64, 74, 148, 0.1)";
    TeachAppAndLandingColorPalette["purple_500"] = "rgba(101, 109, 171, 1)";
    TeachAppAndLandingColorPalette["purple_400"] = "rgba(159, 164, 201, 1)";
    TeachAppAndLandingColorPalette["purple_100"] = "rgba(229, 231, 242, 1)";
    TeachAppAndLandingColorPalette["red_600"] = "rgba(190, 81, 88, 1)";
    TeachAppAndLandingColorPalette["red_500"] = "rgba(253, 131, 133, 1)";
    TeachAppAndLandingColorPalette["red_300"] = "rgba(248, 187, 188, 1)";
    TeachAppAndLandingColorPalette["red_100"] = "rgba(255, 243, 243, 1)";
    TeachAppAndLandingColorPalette["transparent"] = "rgba(255, 255, 255, 0)";
    TeachAppAndLandingColorPalette["white"] = "rgba(255, 255, 255, 1)";
    TeachAppAndLandingColorPalette["white_50"] = "rgba(255, 255, 255, 0.5)";
    TeachAppAndLandingColorPalette["yellow_500"] = "rgba(255, 203, 87, 1)";
    TeachAppAndLandingColorPalette["yellow_600"] = "rgba(245, 168, 0, 1)";
    TeachAppAndLandingColorPalette["yellow_100"] = "rgba(255, 239, 205, 1)";
    // colors of external services
    TeachAppAndLandingColorPalette["clever"] = "rgba(63, 112, 250, 1)";
    TeachAppAndLandingColorPalette["rgp"] = "rgba(98, 187, 70, 1)";
    TeachAppAndLandingColorPalette["canope"] = "rgba(203, 237, 233, 1)";
    TeachAppAndLandingColorPalette["canopeDark"] = "rgba(0, 170, 139, 1)";
})(TeachAppAndLandingColorPalette || (TeachAppAndLandingColorPalette = {}));
//# sourceMappingURL=teachAppAndLandingColorPalette.js.map